import { PaginatedData, Trainings } from '../../../../types/interfaces'
import { client } from '../../client'

export class TrainingsService {
  public async getTrainings() {
    return client.get<PaginatedData<Trainings>>('/trainings')
  }
}
